import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ModalExitBeforeTime from "./ModalExitBeforeTime";
import profileImg from "../../assets/images/profile-img.png";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { ConvertDate } from "../Function/ConvertDate";
import { logDOM } from "@testing-library/react";
import Lottie from "react-lottie";
import * as loadingLeaveTap from "../../assets/lottieAnimation/loadingLeaveTap.json";
import * as loadingBar from "../TESTPage/loadingBar.json";
import { calculateDistance } from "../Function/CalculateDistance";

const WorkEntry = ({ isFromDashboard }) => {
  const [entryTimeEntryWeb2, setEntryTimeEntryWeb2] = useState(new Date());

  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;

  const [userInfo, setUserInfo] = useState([]);
  const [startWorkTime2, setStartWorkTime2] = useState();
  const [timeCanLate2, setTimeCanLate2] = useState();
  const [timeOutWork2, setTimeOutWork2] = useState();
  const [isInterval, setIsInterval] = useState(true);

  const [isLeaveToday, setIsLeaveToday] = useState();
  const [isFullDayLeave, setIsFullDayLeave] = useState();
  const [isHolidayToday, setIsHolidayToday] = useState();
  const [entryOBJ, setEntryOBJ] = useState({
    isEntry: false,
    isOut: false,
    timeEntry: "",
    timeExit: "",
    entryWith: "",
    exitWith: "",
    exitBeforeTime: "",
    confirmOut: false,
  });
  const [blockCheckIn, setBlockCheckIn] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const [location, setLocation] = useState({ lat: null, lng: null });
  const [gpsSetting, setGpsSetting] = useState();

  const [show, setShow] = useState(false);

  const [alertText, setAlertText] = useState();

  const distance = async () => {
    let distances = await calculateDistance(gpsSetting?.latitude, gpsSetting?.longitude, location.lat, location.lng)
    return distances
  }

  ///////////////// เรียก UserInfo
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res.data.result);
      } catch (err) {
        console.error(err);
      }
    };

    const getGPSSetting = async () => {
      try {
        const res = await axios.get(baseURL + "/api/time/gpsSetting", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setGpsSetting(res?.data?.result);
      } catch (err) {
        console.error(err);
      }
    };

    // const checkCanCheckIn = () => {}

    getUserInfo();
    getGPSSetting();
    isTodayEntry(user_id);
    checkStatusLeave();
    checkTodayIsHoliday();
    checkTodayEntryExit();
    checkTodayEntryExit2();
    getLocation()
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude.toFixed(7), lng: longitude.toFixed(7) });
        },
        (err) => {
          // setError(err.message);
          // if (err.code === err.PERMISSION_DENIED) {
          //   alert("ตำแหน่งถูกปิดใช้งาน กรุณาตั้งค่าการเปิดใช้งานตำแหน่ง");
          // }
        }
      );
    } else {
      // setError("อุปกรณ์ของคุณไม่รองรับการเปิดใช้งานตำแหน่ง");
    }
  };



  const [deviceType, setDeviceType] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      setDeviceType("android");
    // } else if (/tablet/.test(userAgent)) {
    //   setDeviceType("tablet");
    } else if (/iphone/.test(userAgent)) {
      setDeviceType("iphone");
    } else if (/ipad/.test(userAgent)) {
      setDeviceType("ipad");
    } else if (/tablet/.test(userAgent)) {
      setDeviceType("tablet");
    } else {
      setDeviceType("desktop");
    }
  }, []);

    ///////////////////ตรวจสอบว่าวันนี้ใช่วันหยุดหรือไม่
    const checkTodayIsHoliday = async () => {
      try {
        const url = `${baseURL}/api/time/history`;
  
        const params = new URLSearchParams({
          page: 1,
          size: 5,
          "order[0]": "scan_date",
          "order[1]": "DESC",
          "filter[user_id][0]": user_id,
          "filter[entry_exit_status][0]": "2",
          "filter[entry_exit_status][1]": "3",
          date_start: ConvertDate(new Date()).toOnlyDate(),
          date_end: ConvertDate(new Date()).toOnlyDate(),
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
           params,
        };
        const res = await axios.get(url, config);
          return res?.data?.result?.length !== 0
          ? setIsHolidayToday(res?.data?.result)
          : setIsHolidayToday([]);
      } catch (err) {
        console.error(err);
      }
    };

  useEffect(() => {
    if (isInterval) {
      const intervalID = setInterval(() => {
        const newTime = new Date(entryTimeEntryWeb2.getTime() + 1000);
        setEntryTimeEntryWeb2(newTime);
      }, 1000);
      return () => clearInterval(intervalID);
    }
  }, [entryTimeEntryWeb2, isInterval]);

  /////////////////////// เปิด Modal กรณีที่ต้องการออกงานก่อนเวลา
  const handleCloseModalExitBeforeTime = () => {
    setEntryOBJ((prev) => ({ ...prev, exitBeforeTime: false }));
  };

  const convertToTime = (timeNow) => {
    const convertOBJ = {
      getTimeOutWork: () => {
        let part1 = timeNow?.split("T")[1];
        let part2 = part1?.split(".")[0];
        let hours = part2?.split(":")[0];

        return `${parseInt(hours) + 8}:${part2?.split(":")[1]}:${
          part2?.split(":")[2]
        }`;
      },
      getTime: () => {
        let timePart1 = timeNow?.split("T")[1];
        let timePart2 = timePart1?.split(".")[0];

        return timePart2;
      },
    };
    return convertOBJ;
  };
  
  const [todayEntryExit, setTodayEntryExit] = useState([])

  ///////////////// API สำหรับใช้กดเข้างาน
  // const CheckInWork = async () => {
  //   try {
  //     const res = await axios.post(
  //       baseURL + "/api/time/entry",
  //       {
  //         user_start_work_id : `${user.user_start_work_id}`,
  //         user_start_work_name : user.user_start_work_name || '',
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     setEntryOBJ((prev) => ({
  //       ...prev,
  //       isEntry: true,
  //       timeEntry: res?.data?.timeEntry,
  //       entryWith: "website",
  //     }));
  //     setTodayEntryExit([
  //       {
  //         entry_exit_status: 0,
  //         scan_date: res?.data?.timeEntry
  //       }
  //     ])
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleCheckIn = async () => {
     let distances = await distance() //กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง
     if (gpsSetting?.force === 'on' && gpsSetting?.setting === 'off') {
      if (location.lat && location.lng) {
        await CheckInWork({
        user_start_work_id : user.user_start_work_id ? `${user.user_start_work_id}` : '',
        user_start_work_name : user.user_start_work_name ? `${user.user_start_work_name}` : '',
        latitude : location.lat,
        longitude : location.lng,
        device_type_name : deviceType,
      })
      } else {
        setShow(true)
        setAlertText('กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง')
      }
     } else if (gpsSetting?.force === 'on' && gpsSetting?.setting === 'on') {
        if (location.lat && location.lng) {
            if (distances && distances <= 0.2) {
            await CheckInWork({
              user_start_work_id : user.user_start_work_id ? `${user.user_start_work_id}` : '',
              user_start_work_name : user.user_start_work_name ? `${user.user_start_work_name}` : '',
            latitude : location.lat,
            longitude : location.lng,
            device_type_name : deviceType,
          })
          } else {
            setShow(true)
            setAlertText('คุณไม่ได้อยู่ในสำนักงาน')
          }
        } else {
          setShow(true)
          setAlertText('กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง')
        }
      } else {
        await CheckInWork({
          user_start_work_id : user.user_start_work_id ? `${user.user_start_work_id}` : '',
          user_start_work_name : user.user_start_work_name ? `${user.user_start_work_name}` : '',
        })
      }
  }

  const CheckInWork = async (data) => {
    // if (!(data?.user_start_work_id || data?.user_start_work_name)) {
    //   setShow(true)
    //   setAlertText('กรุณาตั้งรอบการทำงาน')
    //   return;
    // }

    try {
      await axios.post(
        baseURL + "/api/time/entry",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ).then(async (res) => {
          setEntryOBJ((prev) => ({
            ...prev,
            isEntry: true,
            timeEntry: res?.data?.timeEntry,
            entryWith: "website",
          }));
          setTodayEntryExit([
            {
              entry_exit_status: 0,
              scan_date: res?.data?.timeEntry
            }
          ])
          setLoading(true)
          
          setTimeout(async () => {
            await checkTodayEntryExit2();
          setLoading(false)
          }, 500);
      }).catch(err => console.error(err))
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheckOut = async (date, date_time_out) => {
    let distances = await distance() //กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง
    if (gpsSetting?.force === 'on' && gpsSetting?.setting === 'off') {
     if (location.lat && location.lng) {
       await CheckOutWork(date, date_time_out, {
       latitude : location.lat,
       longitude : location.lng,
       device_type_name : deviceType,
     })
     } else {
       setShow(true)
       setAlertText('กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง')
     }
    } else if (gpsSetting?.force === 'on' && gpsSetting?.setting === 'on') {
       if (location.lat && location.lng) {
           if (distances && distances <= 0.2) {
           await CheckOutWork(date, date_time_out, {
           latitude : location.lat,
           longitude : location.lng,
           device_type_name : deviceType,
         })
         } else {
           setShow(true)
           setAlertText('คุณไม่ได้อยู่ในสำนักงาน')
         }
       } else {
         setShow(true)
         setAlertText('กรุณาเปิดตั้งค่าการใช้งานตำแหน่ง')
       }
     } else {
       await CheckOutWork(date, date_time_out)
     }
 }

  /////////////////////// API สำหรับใช้กดออกงาน
  const CheckOutWork = async (timeNow, timeOut, data = {}) => {
    try {
      if (timeNow < timeOut && !entryOBJ.timeExit) {
        setEntryOBJ((prev) => ({ ...prev, exitBeforeTime: true }));
      } else {
        const res = await axios.post(
          baseURL + "/api/time/exit",
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEntryOBJ((prev) => ({
          ...prev,
          timeExit: res?.data?.timeExit,
          exitWith: "website",
          isEntry: true,
          isOut: true,
        }));
        setLoading(true)
          
        setTimeout(async () => {
          await checkTodayEntryExit2();
        setLoading(false)
        }, 500);
        // window.location.reload();
      }
    } catch (err) {
      console.error(err);
    }
  };

  ///////////////////////// API สำหรับตรวจสอบสถานะการเข้างานในวันนี้
  const isTodayEntry = async (id) => {
    try {
      const res = await axios.get(baseURL + `/api/time/checkEntryExit/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        res?.data?.status === true &&
        res?.data?.timeEntry &&
        !res?.data?.hasOwnProperty("timeExit")
      ) {
        setEntryOBJ((prev) => ({
          ...prev,
          isEntry: res?.data?.status,
          timeEntry: res?.data?.timeEntry,
          entryWith: res?.data?.entryWith,
        }));
      }
      if (
        res?.data?.status === true &&
        res?.data?.timeEntry &&
        res?.data?.timeExit
      ) {
        setEntryOBJ((prev) => ({
          ...prev,
          isEntry: res?.data?.status,
          timeEntry: res?.data?.timeEntry,
          entryWith: res?.data?.entryWith,
          isOut: res?.data?.status,
          timeExit: res?.data?.timeExit,
          exitWith: res?.data?.exitWith,
        }));
        // setIsInterval(false);
      }
    } catch (err) {
      // console.error(err);
    }
  };

  // useEffect(() => {
  //   first
  
  //   return () => {
  //     second
  //   }
  // }, [third])
  
  const [dataCheckStatusWork, setDataCheckStatusWork] = useState([])
  ////////////////// ใช้สำหรับตรวจสอบสถานะ เช่น เข้างาน สาย ขาด ลา วันหยุด return-> JSX
  const checkStatusWork = () => {
    let content;
     if (dataCheckStatusWork.length > 0) {
      let entry = dataCheckStatusWork?.find(obj => obj?.entry_exit_status === 0);
      let exit = dataCheckStatusWork?.find(obj => obj?.entry_exit_status === 1);
      let [mainHour,mainMinute] = user?.user_start_work_name ? user?.user_start_work_name?.split('.')?.map(Number) : [9,30]
      let mainTime = new Date(new Date().setHours(mainHour, mainMinute, 59, 0))
      let startDay = new Date(new Date().setHours(4, 0, 0, 0))
      let morningStart = new Date(new Date().setHours(7, 30, 0, 0))
      let morningLateLimit = new Date(mainTime.getTime() + 30 * 60000);
      let afternoonStart = new Date(new Date().setHours(13, 0, 0, 0))
      let afternoonLateStart = new Date(new Date().setHours(14, 0, 0, 0))
      let afternoonLateLimit = new Date(new Date().setHours(14, 30, 59, 0))
      let entryScanDate = new Date(new Date(entry?.scan_date).getTime() - 7 * 60 * 60 * 1000);

      let statusText = "ยังไม่ลงเวลาเข้างาน"
      let color = "secondary"
      let late = entry?.late

      

      if (late === 0) {
        statusText = "เข้างาน (ช่วงเช้า)"
        color = "success"
      } else if (late === 4) {
        statusText = "เข้างาน (ช่วงบ่าย)"
        color = "success"
      } else if (late === 2) {
        statusText = "สาย (ช่วงเช้า)"
        color = "warning"
      } else if (late === 3){
        statusText = "สาย (ช่วงบ่าย)"
        color = "warning"
      } else if (late === 5){
        statusText = "ขาดงาน"
        color = "danger"
      }

      if (exit){
        let workingTime = exit?.working_hours_decimal
        if (((entryScanDate >= startDay) && (entryScanDate <= morningLateLimit)) && (workingTime >= 3.5) && (workingTime < 8)) {
          statusText = "ทำงานครึ่งเช้า"
          color = "primary"
        } else if ((((entryScanDate >= afternoonStart) && (entryScanDate <= afternoonLateLimit)) || late === 4) && (workingTime >= 3.5) && (workingTime < 8)) {
          statusText = "ทำงานครึ่งบ่าย"
          color = "primary"
        } else if (workingTime >= 8) {
          statusText = "เต็มเวลา"
          color = "success"
        } else {
          statusText = "ขาดงาน"
          color = "danger"
        }
      }

        statusText = isLeaveToday && `${statusText}${isLeaveToday[0] ? ` (${isLeaveToday[0]?.leave_name})` : ""}`

        content = <h4 className={`entry-title text-${color}`}>
            {statusText}
          </h4>
     } else {
        if (blockCheckIn) {
          content = <h4 className="entry-title text-danger">
          ขาดงาน
          </h4>
        } else if (isLeaveToday?.length > 0) {
          content = <h4 className="entry-title text-secondary">
          {isLeaveToday[0]?.leave_name || 'การลาที่ไม่ระบุ'}
          </h4>
        } else {
          content = <h4 className="entry-title text-secondary">
          ยังไม่ลงเวลาเข้างาน
          </h4>
        }
     }
     return content;
  };

  //////////////////// ตรวจสอบว่าวันนี้มีการลาหรือไม่
  const checkStatusLeave = async () => {
    try {
      const url = baseURL + "/api/leave/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[leave_status][0]": "0",
        "filter[leave_status][1]": "5",
        "filter[leave_dmy_start][0]": ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_dmy_end][0]": ConvertDate(new Date()).toOnlyDate(),
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      return res?.data?.result?.length !== 0
        ? (setIsLeaveToday(res?.data?.result),
          res?.data?.result[0]?.leave_days > 0.5
            ? setIsFullDayLeave(true)
            : setIsFullDayLeave(false))
        : setIsLeaveToday([]);
    } catch (err) {
      console.error(err);
    }
  };

  const checkTodayEntryExit2 = async () => {
      try {
            const url = `${baseURL}/api/time/history`;

            const params = new URLSearchParams({
              page: 1,
              size: 5,
              "order[0]": "scan_date",
              "order[1]": "DESC",
              "filter[user_id][0]": user_id,
              "filter[entry_exit_status][0]": "0",
              "filter[entry_exit_status][1]": "1",
              date_start: ConvertDate(new Date()).toOnlyDate(),
              date_end: ConvertDate(new Date()).toOnlyDate(),
            })

            const config = {
              headers: { Authorization: `Bearer ${token}`}, params
            };
            const res = await axios.get(url, config);
            // if (conditions) {
              // while (true) {
                if (res?.data?.result.length > 0) {
                  setDataCheckStatusWork(res?.data?.result)
                  // break;
                }
              // }
            // } else {
              // setDataCheckStatusWork(res?.data?.result)
            // }
      } catch (err) {
        console.error(err);
      }

  };

  const checkTodayEntryExit = async () => {
    try {
      const res = await axios.get(baseURL + `/api/time/checkEntryExit/${user_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status === true) {
        setTodayEntryExit([
          {
            entry_exit_status:0,
            scan_date:res?.data?.timeEntry
          }
        ])
      } else {
        
      }

    } catch (err) {
      console.error(err);
    }
  };
  
  /////////////////// รอบการเข้างานจาก UserInfo
  useEffect(() => {
    let hours, minutes;
    if (userInfo) {
      hours = parseInt(userInfo?.user_start_work_name?.split(".")[0]);
      minutes = parseInt(userInfo?.user_start_work_name?.split(".")[1]);
    }
    if (isLeaveToday?.length > 0) {
      
      if (isLeaveToday[0]?.leave_days < 1) {
        if (
          isLeaveToday[0]?.leave_from_timetype === "1" &&
          isLeaveToday[0]?.leave_to_timetype === "1"
        ) {
          setStartWorkTime2(
            new Date(new Date().setHours(13, 0, 0, 0))
          );
          setTimeOutWork2(
            new Date(new Date().setHours(hours + 8, minutes, 0, 0))
          );
        } else {
          setStartWorkTime2(
            new Date(new Date().setHours(hours, minutes, 0, 0))
          );
          setTimeOutWork2(
            new Date(new Date().setHours(12, 0, 0, 0))
          );
        }
      }
    } else {
      setStartWorkTime2(new Date(new Date().setHours(hours, minutes, 0, 0)));
      setTimeCanLate2(new Date(new Date().setHours(hours, minutes + 30, 0, 0)));

      let entry = todayEntryExit?.find(obj => obj?.entry_exit_status === 0);
      let entryScanDate = new Date(new Date(entry?.scan_date).getTime() - 7 * 60 * 60 * 1000);
      let mainTime = new Date(new Date().setHours(9, 30, 0, 0))
      let morningStartTime = new Date(new Date().setHours(7, 30, 0, 0))
      let morningStartButton = new Date(new Date().setHours(4, 0, 0, 0))
      let morningLateLimit = new Date(mainTime.getTime() + 30 * 60000)
      let afternoonStart = new Date(new Date().setHours(13, 0, 0, 0))
      let afternoonLateLimit = new Date(new Date().setHours(14, 30, 0, 0))
      let entryHr = entryScanDate.getHours()
      let entryMin = entryScanDate.getMinutes()
      let entrySec = entryScanDate.getSeconds()

      if (entryScanDate <= morningStartTime) { //ลงก่อน 7.30 ให้บวก 8 จาก 7.30
        entryHr = 7
        entryMin = 30
        entrySec = 0
      } else if ((entryScanDate > morningLateLimit) && (entryScanDate < afternoonStart)) { //ลงหลัง 10.00 - ก่อน 13.00
        entryHr = 13
        entryMin = 0
        entrySec = 0
      }

      let appropriateTimeOut = new Date(new Date().setHours(entryHr + 8, entryMin, entrySec, 0))

      if ((entryScanDate > morningLateLimit) && (entryScanDate <= afternoonLateLimit)) {
        appropriateTimeOut = new Date(new Date().setHours(entryHr + 3, entryMin + 30, entrySec, 0))
      }

      // let now = new Date()
      let now = new Date(new Date().setHours(7, 0, 0, 0))

      if ((now > afternoonLateLimit) || (now < morningStartButton)) {
        setBlockCheckIn(true)
      }
      setTimeOutWork2(appropriateTimeOut);
    }
  }, [userInfo, isLeaveToday, todayEntryExit]);

  const AppropriateTimeOut = () => {
    if((!entryOBJ?.isEntry || todayEntryExit.length === 0) && blockCheckIn ){
      return(
        <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingBar.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
            width={200}
            height={52.1333}

          />
        )
      } else {
        return (
          (
            isLeaveToday?.length > 0 ? "" :
              <Row>
                <Col>
                  <Row>
                    <Col xxl={12} className="d-flex justify-content-center">
                      <h5>{entryOBJ?.isEntry ? "ออกงานได้หลังเวลา" : null}</h5>
                    </Col>
                    <Col xxl={12} className="d-flex justify-content-center">
                      <h5 style={{ color: "#8c8c8c" }}>
                        {entryOBJ?.isEntry &&
                            `${ConvertDate(timeOutWork2)?.toTimeHMS()} น.`}
                      </h5>
                    </Col>
                  </Row>
                </Col>
    
                {/* <Col>
                  <Row>
                    <Col xxl={12} className="d-flex justify-content-center">
                      <h5>{entryOBJ?.isEntry ? "ออกงานได้หลังเวลา (เต็มวัน)" : null}</h5>
                    </Col>
                    <Col xxl={12} className="d-flex justify-content-center">
                      <h5 style={{ color: "#8c8c8c" }}>
                        {entryOBJ?.isEntry &&
                            `${ConvertDate(timeOutWork2)?.toTimeHMS()} น.`}
                      </h5>
                    </Col>
                  </Row>
                </Col> */}
    
              </Row>
          )
        )
      }
      
    
  }
  

  const entryAlertModal = () => {
    return(
      <Modal
        size="md"
        centered
        isOpen={show}
        onKeyDown={(e) => {if (e.key === 'Enter')setShow(false)}}
        tabIndex="0"
        toggle={() => {setShow(false);}}
      >
        <ModalHeader>{alertText}</ModalHeader>
        <ModalFooter>
          <Button  className="btn btn-primary btn-block"  onClick={() => {setShow(false);}}>
            รับทราบ
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  const checkTimeForButton = () => {
    const now = new Date();
    const hour = now.getHours();
  
    // เช็คว่าชั่วโมงอยู่ในช่วงหลังเที่ยงคืนถึงตี 4 หรือไม่
    return hour >= 0 && hour < 4;
  }
  
  const handleClick = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    // getLocation()
    handleCheckIn()
    // await checkTodayEntryExit();
    // window.location.reload();
    // ToggleInterval();
    setTimeout(() => setIsDisabled(false), 2000);
  };

  const hasLocation = (gpsSetting?.latitude && gpsSetting?.longitude && location.lat && location.lng)

  return (
    <React.Fragment>
      <ModalExitBeforeTime
        entryOBJ={entryOBJ}
        setEntryOBJ={setEntryOBJ}
        handleCloseModalExitBeforeTime={handleCloseModalExitBeforeTime}
        outWorkFucn = {()=> {handleCheckOut()}}
      />

      {entryAlertModal()}

      <Card
        style={{ minHeight: isFromDashboard === true ? "200px" : "450px" }}
        className="overflow-hidden"
      >
        {isFromDashboard === true ? null : (
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs={8}>
                <div className="text-primary p-4">
                  <h5 className="text-primary" style={{ fontFamily: "Kanit" }}>
                    สวัสดีคุณ{user?.user_name}
                  </h5>
                  <h6>ยินดีต้อนรับเข้าสู่ สำนักงาน ก.พ.ร.</h6>
                </div>
              </Col>
              <Col xs={4} className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
        )}
        {loading ? 
          <div>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingLeaveTap.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              width={250}
              height={250}
            />
          </div>
        :<Fragment>
          <Row>
            <Col xxl={12} xl={6}>
              <CardBody>
                <Row>
                    <Col
                      className="mb-3"
                      xxl={12}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <h3>การเข้างานวันนี้</h3>
                    </Col>
                    <Col xxl={12} xl={12}>
                      <Row>
                        <Col
                          xxl={5}
                          xl={6}
                          xs={5}
                          style={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <h4 className="entry-title">ขณะนี้เวลา: </h4>
                        </Col>
                        <Col
                          xxl={7}
                          xl={6}
                          xs={7}
                          style={{
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          <h4 className="entry-title">
                            {entryTimeEntryWeb2?.toLocaleTimeString("th-TH", {
                              hour12: false,
                            })}
                          </h4>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xxl={5}
                          xl={6}
                          xs={5}
                          style={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <h4 className="entry-title">เข้างานเวลา: </h4>
                        </Col>
                        <Col
                          xxl={7}
                          xl={6}
                          xs={7}
                          style={{
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          <h4 className="entry-title">
                            {entryOBJ?.timeEntry
                              ? `${convertToTime(
                                  entryOBJ?.timeEntry
                                )?.getTime()}`
                              : "-"}
                          </h4>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xxl={5}
                          xl={6}
                          xs={5}
                          style={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <h4 className="entry-title">ออกงานเวลา: </h4>
                        </Col>
                        <Col
                          xxl={7}
                          xl={6}
                          xs={7}
                          style={{
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          <h4 className="entry-title">
                            {entryOBJ?.isOut
                              ? `${convertToTime(entryOBJ?.timeExit)?.getTime()}`
                              : "-"}
                          </h4>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl={5} xl={6} xs={5} style={{display: "flex", justifyContent: "end"}}>
                          <h4 className="entry-title">สถานะ: </h4>
                        </Col>
                        <Col xxl={7} xl={6} xs={7} style={{display: "flex", justifyContent: "start"}}>
                          {checkStatusWork()}
                        </Col>
                      </Row>
                    </Col>
                </Row>
                <Row
                    className="me-2"
                    style={{
                      display: "flex",
                      alignItems: "end",
                    }}
                  >
                    <Col style={{ display: "flex", justifyContent: "end" }}>
                      <h6
                        className="font-size-15"
                        style={{
                          color: "rgba(255,100,100,0.8)",
                        }}
                      >
                        {entryOBJ?.isEntry ? <> </> : null}
                      </h6>
                    </Col>
                </Row>
                {AppropriateTimeOut()}
              </CardBody>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col
              className=""
              xxl={12}
              xl={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                style={{
                  background: !entryOBJ?.isEntry ? "#336600" : "#929292",
                }}
                className="text-white me-2"
                size="lg"
                disabled={entryOBJ?.isEntry || blockCheckIn || checkTimeForButton() || !hasLocation}
                onClick={() => {
                  handleClick()
                }}
              >
                <i className="fa-solid fa-right-to-bracket me-2"></i>
                เข้างาน
              </Button>
              <Button
                style={{ background: "#da293c" }}
                className=" text-white"
                size="lg"
                disabled={!entryOBJ?.isEntry ? true : false}
                outline={entryOBJ?.isEntry && entryOBJ?.isOut ? false : true}
                onClick={() => {
                  // CheckOutWork(new Date(), timeOutWork2);
                  handleCheckOut(new Date(), timeOutWork2);
                }}
              >
                ออกงาน 
                <i className="fa-solid fa-right-from-bracket ms-2"></i>
              </Button>
            </Col>
          </Row>
        </Fragment>
        }
      </Card>
    </React.Fragment>
  );
};

export default WorkEntry;
